import { gql } from "@apollo/client";

export default gql`
  query getAccountSetupReportingQuery($organizationId: Int!) {
    me {
      id
      calendarIsSyncingForFirstTime
      managers {
        edges {
          node {
            id
            firstName
            lastName
            name
            email
            status
            avatar
          }
        }
      }
      directReports {
        edges {
          node {
            id
            firstName
            lastName
            name
            email
            status
            avatar
          }
        }
      }
      reportingPredictions(organizationId: $organizationId) {
        status
        generatedAt
        predictions {
          confidence
          predictedDirection
          otherUser {
            id
            firstName
            lastName
            name
            email
            status
            avatar
          }
        }
      }
    }
  }
`;
